import { useState, useEffect } from 'react'
import axios from 'axios'

const GiftStatusMonitor = () => {
  const [giftData, setGiftData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [lastUpdated, setLastUpdated] = useState(null)
  const [selectedDate, setSelectedDate] = useState(null)

  // 可選擇的日期選項
  const dateOptions = [
    { value: '2025-05-20', label: '5/20' },
    { value: '2025-05-21', label: '5/21' },
    { value: '2025-05-22', label: '5/22' },
    { value: '2025-05-23', label: '5/23' },
  ]

  // 初始化時，設置默認選擇為當前日期或最接近的可用日期
  useEffect(() => {
    const today = new Date()
    const todayString = today.toISOString().split('T')[0]

    // 檢查今天是否在可選日期範圍內
    const matchingDate = dateOptions.find(
      (option) => option.value === todayString
    )

    if (matchingDate) {
      setSelectedDate(matchingDate.value)
    } else {
      // 如果今天不在範圍內，則選擇第一個日期
      setSelectedDate(dateOptions[0].value)
    }
  }, [])

  const fetchGiftStatus = async () => {
    if (!selectedDate) return

    try {
      setLoading(true)

      // 獲取當天日期格式化為 YYYY-MM-DD
      // const today = new Date()
      // const dateString = today.toISOString().split('T')[0]

      // 請求體
      const requestBody = {
        gift_ids: [
          'COMP25_01',
          'COMP25_02',
          'COMP25_03',
          'COMP25_04',
          'COMP25_05',
          'COMP25_06',
        ],
        date: selectedDate,
      }
      const host = process.env.REACT_APP_HOST || 'https://nezcdev.dataa.com.tw'

      // 使用 axios 發送 POST 請求
      const response = await axios.post(
        host + '/clientWeb/v1/GetGiftStatus',
        requestBody,
        {
          headers: {
            'Content-Type': 'text/plain; charset=UTF-8',
            // 'Content-Type': 'application/json',
            Accept: '*/*',
            ac: 'aaa',
            tk: 'aaa',
          },
        }
      )

      setGiftData(response.data.data || [])
      //   console.log('response', response)
      setLastUpdated(new Date().toLocaleTimeString())
      setError(null)
    } catch (err) {
      console.error('獲取禮品狀態失敗:', err)
      setError(
        err.response
          ? `錯誤: ${err.response.status} ${err.response.statusText}`
          : err.message
      )
    } finally {
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   // 初始載入
  //   fetchGiftStatus()

  //   // 設置每5秒更新一次
  //   const intervalId = setInterval(fetchGiftStatus, 5000)

  //   // 清理函數
  //   return () => clearInterval(intervalId)
  // }, [])

  useEffect(() => {
    // 當選定日期變化時，重新獲取數據
    if (selectedDate) {
      fetchGiftStatus()

      // 設置每5秒更新一次
      const intervalId = setInterval(fetchGiftStatus, 5000)

      // 清理函數
      return () => clearInterval(intervalId)
    }
  }, [selectedDate])

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value)
  }

  const styles = {
    container: {
      width: '100%',
      margin: '0 auto',
      backgroundColor: '#000',
      color: '#fff',
      minHeight: '100vh',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '16px',
      flexDirection: window.innerWidth < 768 ? 'column' : 'row',
      padding: '16px',
    },
    title: {
      fontSize: window.innerWidth < 768 ? '20px' : '24px',
      fontWeight: 'bold',
      color: '#fff',
    },
    timestamp: {
      fontSize: '14px',
      color: '#aaa',
      marginTop: window.innerWidth < 768 ? '8px' : '0',
    },
    dateSelector: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '16px',
      padding: '0 16px',
    },
    dateSelectorLabel: {
      marginRight: '12px',
      fontSize: '16px',
    },
    dateDropdown: {
      padding: '8px 12px',
      backgroundColor: '#333',
      color: '#fff',
      border: '1px solid #444',
      borderRadius: '4px',
      fontSize: '16px',
      cursor: 'pointer',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      margin: '32px 0',
    },
    loadingSpinner: {
      width: '32px',
      height: '32px',
      border: '2px solid transparent',
      borderBottom: '2px solid #fff',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
    errorContainer: {
      backgroundColor: '#5c0000',
      borderLeft: '4px solid #ff5252',
      color: '#ffcccc',
      padding: '16px',
      margin: '0 16px 16px',
      borderRadius: '4px',
    },
    tableContainer: {
      overflowX: 'auto',
      padding: '0 16px',
    },
    table: {
      minWidth: '100%',
      backgroundColor: '#222',
      border: '1px solid #444',
      borderRadius: '8px',
      borderCollapse: 'collapse',
    },
    tableHead: {
      backgroundColor: '#333',
    },
    tableHeaderCell: {
      padding: '12px 16px',
      borderBottom: '1px solid #444',
      textAlign: 'left',
    },
    tableRow: (index) => ({
      backgroundColor: index % 2 === 0 ? '#333' : '#222',
    }),
    tableCell: {
      padding: '12px 16px',
      borderBottom: '1px solid #444',
    },
    tableCellCenter: {
      padding: '12px 16px',
      borderBottom: '1px solid #444',
      textAlign: 'center',
    },
    stockIndicator: (isFull) => ({
      padding: '4px 8px',
      borderRadius: '16px',
      backgroundColor: isFull ? '#5c0000' : '#3450be',
      color: '#fff',
      display: 'inline-block',
    }),
    emptyMessage: {
      backgroundColor: '#5c4000',
      borderLeft: '4px solid #ffc107',
      color: '#fff8e1',
      padding: '16px',
      margin: '0 16px',
      borderRadius: '4px',
    },
    hiddenOnMobile: {
      display: window.innerWidth < 768 ? 'none' : 'table-cell',
    },
  }

  const formatName = (name) => {
    if (!name) return ''
    // 只保留中文部分（在換行符前的內容）
    return name.split('\\n')[0]
  }

  const formatDescription = (desc) => {
    if (!desc) return ''
    // 只保留中文部分（在換行符前的內容）
    return desc.split('\\n')[0]
  }

  // Add keyframes for the loading spinner animation
  if (!document.getElementById('spinnerAnimation')) {
    const style = document.createElement('style')
    style.id = 'spinnerAnimation'
    style.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `
    document.head.appendChild(style)
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Computex 2025 禮品狀態</h1>
        <div style={styles.timestamp}>
          {lastUpdated ? `上次更新: ${lastUpdated}` : '載入中...'}
        </div>
      </div>

      <div style={styles.dateSelector}>
        <div style={styles.dateSelectorLabel}>選擇日期:</div>
        <select
          style={styles.dateDropdown}
          value={selectedDate || ''}
          onChange={handleDateChange}
        >
          {dateOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {loading && giftData.length === 0 && (
        <div style={styles.loadingContainer}>
          <div style={styles.loadingSpinner}></div>
        </div>
      )}

      {error && (
        <div style={styles.errorContainer}>
          <p>錯誤: {error}</p>
        </div>
      )}

      {giftData.length > 0 && (
        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead style={styles.tableHead}>
              <tr>
                <th style={styles.tableHeaderCell}>禮品名稱</th>
                {/* <th
                  style={{
                    ...styles.tableHeaderCell,
                    ...styles.hiddenOnMobile,
                  }}
                >
                  描述
                </th> */}
                <th style={styles.tableHeaderCell}>上午庫存</th>
                <th style={styles.tableHeaderCell}>全天庫存</th>
                {/* <th
                  style={{
                    ...styles.tableHeaderCell,
                    ...styles.hiddenOnMobile,
                  }}
                >
                  開始時間
                </th>
                <th
                  style={{
                    ...styles.tableHeaderCell,
                    ...styles.hiddenOnMobile,
                  }}
                >
                  結束時間
                </th> */}
              </tr>
            </thead>
            <tbody>
              {giftData.map((gift, index) => (
                <tr key={index} style={styles.tableRow(index)}>
                  <td style={{ ...styles.tableCell, fontWeight: 'medium' }}>
                    {formatName(gift.name)}(
                    {formatDescription(gift.description)})
                  </td>
                  {/* <td style={{ ...styles.tableCell, ...styles.hiddenOnMobile }}>
                    {formatDescription(gift.description)}
                  </td> */}
                  <td style={styles.tableCellCenter}>
                    <span
                      style={styles.stockIndicator(
                        gift.morning_count >= gift.max_morning_stock
                      )}
                    >
                      {gift.max_morning_stock - gift.morning_count} /{' '}
                      {gift.max_morning_stock}
                    </span>
                  </td>
                  <td style={styles.tableCellCenter}>
                    <span
                      style={styles.stockIndicator(
                        gift.daily_count >= gift.max_daily_stock
                      )}
                    >
                      {gift.max_daily_stock - gift.daily_count} /{' '}
                      {gift.max_daily_stock}
                    </span>
                  </td>
                  {/* <td style={{ ...styles.tableCell, ...styles.hiddenOnMobile }}>
                    {gift.start_time}
                  </td>
                  <td style={{ ...styles.tableCell, ...styles.hiddenOnMobile }}>
                    {gift.end_time}
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>

          {/* 行動版顯示開始與結束時間 */}
          {/* {giftData.map((gift, index) => (
            <div key={`mobile-${index}`} style={styles.mobileTimeInfo}>
              <div style={styles.mobileTimeGrid}>
                <div style={styles.mobileTimeLabel}>開始時間:</div>
                <div>{gift.start_time}</div>
                <div style={styles.mobileTimeLabel}>結束時間:</div>
                <div>{gift.end_time}</div>
                <div style={styles.mobileTimeLabel}>名稱:</div>
                <div>{formatName(gift.name)}</div>
              </div>
            </div>
          ))} */}
        </div>
      )}

      {!loading && giftData.length === 0 && !error && (
        <div style={styles.emptyMessage}>
          <p>沒有找到禮品數據</p>
        </div>
      )}
    </div>
  )
}

export default GiftStatusMonitor
